import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApiRoutes} from "../../../config/api-routes";
import {FromSettings} from "../model/email-setting/FromSettings";

@Injectable()
export class EmailSettingsService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly apiRoutes: ApiRoutes
  ) {}

  public getFromAdress() {
    return this.httpClient.get(
      this.apiRoutes.BUSINESS_EMAIL_FROM_ADDRESS
    );
  }

  public saveFromAddress(address: string) {
    return this.httpClient.post<FromSettings>(
      this.apiRoutes.BUSINESS_EMAIL_FROM_ADDRESS,
      { address}
    );
  }
}
